import {
  IncomingMaterialStatus,
  type MaterialOrder,
  type GroupedUnplannedDelivery
} from '@domain/material-storage'
import {DatetimeValue} from '@widgets/stock-card'
import {Moment} from 'moment-timezone'

export {
  IncomingMaterialStatus,
  MaterialOrderStatus,
  type AuditFields,
  type MaterialDelivery,
  type MaterialOrder,
  type MaterialOrderAttachment,
  type ScheduleAgreementDataResponse,
  type EditMaterialOrder,
  type CreateMaterialOrder,
  type ScheduleAgreementDataWithVendor,
  type ScheduleAgreementDataWithoutVendor,
  type ScheduleAgreement,
  type ScheduleAgreementsByVendor,
  type MaterialUnplannedDelivery,
  type GroupedUnplannedDelivery
} from '@domain/material-storage'

export type CanceledIncomingMaterial = {
  status: IncomingMaterialStatus.Cancelled
  order: MaterialOrder
} & DatetimeValue<Moment>

export type PlannedIncomingMaterial = {
  status: IncomingMaterialStatus.Planned
  order: MaterialOrder
} & DatetimeValue<Moment>

export type DeliveredIncomingMaterial = {
  status: IncomingMaterialStatus.Delivered | IncomingMaterialStatus.Overdue
  order: MaterialOrder
} & DatetimeValue<Moment>

export type UnplannedIncomingMaterial = {
  status: IncomingMaterialStatus.Unknown
  unplannedDelivery: GroupedUnplannedDelivery
} & DatetimeValue<Moment>

export type IncomingMaterial =
  | PlannedIncomingMaterial
  | DeliveredIncomingMaterial
  | CanceledIncomingMaterial
  | UnplannedIncomingMaterial

export enum DeliveryStatus {
  Delivered = 'Delivered',
  Overdue = 'Overdue',
  Unknown = 'Unknown'
}
